import React from 'react';

const Loading = ({ message = 'Loading...' }: { message?: string }) => {
  return <h3 id="loading-icon">{message}</h3>;
};

export default Loading;
